<template>
  <div class="product-feeds__page-create">
    <v-row no-gutters>
      <v-col cols="12" class="page-header">
        <redirect title="Product Feeds" route="website.product-feeds-v2" />
        <h1 class="page-title">
          {{ formAction === 'create' ? 'Create Product feed' : 'Edit Product feed' }}
        </h1>
        <v-divider class="my-5"></v-divider>
      </v-col>
      <v-col v-if="isFeedLoading" cols="12" style="padding: 0px !important; margin-top: 16px">
        <SkeletonLoaders class="w-full" type="card-heading, list-item-three-line" />
      </v-col>
      <v-col v-else cols="12">
        <v-row>
          <v-col sm="8" cols="12">
            <div class="card-form">
              <InputDefault
                :isValidate="true"
                label="Feed name"
                fieldName="Feed name"
                :model="['feed', 'name']"
                placeholder="Collection name - Product Feed"
                class="pa-0"
              />
              <h4 class="mt-2">All products or just some of them?</h4>
              <v-radio-group v-model="method">
                <v-radio
                  :disabled="existsAllProduct && existsAllProduct.length > 0"
                  label="All products"
                  value="allProducts"
                ></v-radio>
                <v-radio label="Products from selected collections" value="Collections"></v-radio>
              </v-radio-group>
              <v-autocomplete
                v-if="method == 'Collections'"
                multiple
                v-model="feed.collectionsIds"
                :items="collections"
                item-text="title"
                item-value="_id"
                placeholder="Select collections"
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="remove(data.item)"
                  >
                    {{ data.item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
              <!-- <h4 class="mt-2">Export mode</h4>
              <v-radio-group v-model="feed.exportMode" label="">
                <v-radio label="Export only first variation of a product" value="first_variation"></v-radio>
                <v-radio label="Export all variations of a product" value="all_variation"></v-radio>
              </v-radio-group>
              <h4 class="mt-2">Variant title</h4>
              <v-radio-group v-model="feed.addVariantOptionToTitle" label="">
                <v-radio label="Do not add variant title at the end of the title" :value="0"></v-radio>
                <v-radio
                  label="Add all options like color, size, etc behind the title (example: t-shirt red S)"
                  :value="1"
                ></v-radio>
              </v-radio-group>
              <h4 class="mt-2">Auto Update</h4>
              <p style="color: #666">
                This option is only available when your feed file contains less than 10000 products
              </p>
              <v-radio-group v-model="feed.autoUpdate" label="">
                <v-radio label="True" :value="true"></v-radio>
                <v-radio label="False" :value="false"></v-radio>
              </v-radio-group> -->
              <!-- <v-radio-group v-model="feed.is_custom_products" label="Submit products as custom products">
              <v-radio label="True" :value="true"></v-radio>
              <v-radio label="False" :value="false"></v-radio>
            </v-radio-group> -->
              <!-- <v-divider class="my-5"></v-divider> -->
              <!-- <div class="mt-1">
                <h4>Google product category</h4>
                <p style="color: #666">
                  Required if you sell apparel and you need to set gender and age-group too
                </p>
                <v-autocomplete
                  hide-details
                  v-model="feed.googleProductCategory"
                  :items="categories"
                  item-text="value"
                  item-value="id"
                  placeholder="Select Google product category"
                  clearable
                >
                </v-autocomplete>
                <p class="mt-2">
                  Looking for which product category to fit with your products? We have a guide for this.
                </p>
              </div> -->
              <div class="mt-6">
                <h4>Default Gender</h4>
                <p style="color: #666">
                  Required for all apparel items that are focused on people in Brazil, France, Germany, Japan, the UK,
                  and the US as well as all products with assigned age groups.
                </p>
                <InputDefault
                  :itemsSelect="listGender"
                  itemText="name"
                  itemValue="value"
                  typeComponent="select"
                  label=""
                  :model="['feed', 'gender']"
                  placeholder="Select default gender"
                  class="pa-0"
                  clearable
                />
              </div>
              <div class="mt-6">
                <h4>Default Age Group</h4>
                <p style="color: #666">
                  Required for all apparel items in feeds that are focused on people in Brazil, France, Germany, Japan,
                  the UK, and the US as well as all gender-specific products.
                </p>
                <InputDefault
                  :itemsSelect="groups"
                  itemText="name"
                  itemValue="value"
                  typeComponent="select"
                  label=""
                  :model="['feed', 'ageGroup']"
                  placeholder="Select default age group"
                  class="pa-0"
                  clearable
                />
              </div>
            </div>
          </v-col>
          <v-col sm="4" cols="12">
            <div class="card-form">
              <div>
                <InputDefault
                  :itemsSelect="feedTypes"
                  itemText="name"
                  itemValue="value"
                  typeComponent="select"
                  label="Feed Type"
                  :model="['feed', 'feedType']"
                  class="pa-0"
                />
              </div>
              <div class="mt-6">
                <InputDefault
                  :itemsSelect="feedFileFormats"
                  itemText="name"
                  itemValue="value"
                  typeComponent="select"
                  label="File Format"
                  :model="['feed', 'feedFileFormat']"
                  class="pa-0"
                />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="d-flex align-center ml-0 mt-4">
      <v-btn
        v-if="formAction === 'edit'"
        @click="showDialogDelete = true"
        :loading="isDeleteLoading"
        :disabled="isSaving || isDeleteLoading"
        color="error"
        >Delete</v-btn
      >
      <v-btn
        @click="submit"
        :loading="isSaving"
        :disabled="isSaving || isDeleteLoading"
        color="primary"
        class="ml-auto"
        >{{ formAction === 'create' ? 'Create' : 'Save' }}</v-btn
      >
    </div>
    <delete-action v-if="formAction === 'edit'" :content="feed.name" :title="'Delete ' + feed.name" />
  </div>
</template>
<script>
import { collectionApi } from '@/apis/collection';
import { gmcApi } from '@/apis/gmc';
import { required, requiredIf } from 'vuelidate/lib/validators';
import languageJson from '@/assets/json/language.json';

export default {
  props: {
    formAction: {
      type: String,
      default: 'create', //'create' | 'edit'
    },
    feedId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      feed: {
        name: null,
        googleProductCategory: null,
        gender: 'unisex',
        exportMode: 'first_variation',
        collectionsIds: [],
        ageGroup: 'adult',
        addVariantOptionToTitle: 0,
        autoUpdate: false,
        feedType: 'criteo',
        feedFileFormat: 'xml',
      },
      method: 'allProducts',
      listGender: [
        {
          name: 'Male',
          value: 'male',
        },
        {
          name: 'Female',
          value: 'female',
        },
        {
          name: 'Unisex',
          value: 'unisex',
        },
      ],
      groups: [
        {
          name: 'All',
          value: 'all',
        },
        {
          name: 'Adult',
          value: 'adult',
        },
        {
          name: 'Infant',
          value: 'infant',
        },
        {
          name: 'Kids',
          value: 'kids',
        },
        {
          name: 'Teen',
          value: 'teen',
        },
      ],
      feedTypes: [
        {
          name: 'Criteo',
          value: 'criteo',
        },
        {
          name: 'AdRoll',
          value: 'ad_roll',
        },
      ],
      feedFileFormats: [
        {
          name: 'XML',
          value: 'xml',
        },
      ],
      collections: [],
      categories: [],
      isSaving: false,
      isDeleteLoading: false,
      feeds: [],
      languages: languageJson,
      showDialogDelete: false,
      isFeedLoading: false,
    };
  },
  validations: {
    feed: {
      name: {
        required,
      },
    },
  },
  created() {
    this.loadFeeds();
    this.loadCollections();
    this.loadGoogleProductCategory();
    if (this.formAction === 'edit' && this.feedId) {
      this.loadData();
    }
  },
  methods: {
    async loadFeeds() {
      try {
        const gmcParams = {
          feedType: this.feedTypes.map(item => item.value),
        };
        let data = await gmcApi.getProductFeeds(gmcParams);
        this.feeds = data.data.productFeeds;
        if (this.existsAllProduct && this.existsAllProduct.length > 0) {
          this.method = 'Collections';
        }
      } catch (error) {
        console.log(error);
      }
    },
    async loadGoogleProductCategory() {
      try {
        let data = await gmcApi.getGoogleProductCategory();
        this.categories = data.data.categories;
      } catch (error) {
        console.log(error);
      }
    },
    async loadCollections() {
      try {
        let params = {
          page: 1,
          limit: 1000,
        };
        let collectionsData = await collectionApi.get(params);
        this.collections = collectionsData.data.collections;
      } catch (error) {
        console.log(error);
      }
    },
    remove(item) {
      const index = this.feed.collectionsIds.indexOf(item._id);
      if (index >= 0) this.feed.collectionsIds.splice(index, 1);
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isSaving = true;
        try {
          const { ageGroup, gender, googleProductCategory, ...rest } = this.feed;

          const payload = {
            ...rest,
            ...(ageGroup && { ageGroup }),
            ...(gender && { gender }),
            ...(googleProductCategory && { googleProductCategory }),
          };

          if (this.formAction === 'create') {
            await gmcApi.createProductFeed({ productFeed: payload });
            this.$router.push({ name: 'website.product-feeds-v2' });
            this.$store.commit('setMessages', {
              messages: 'Product feed created successfully!',
              type: 'success',
            });
          } else {
            await gmcApi.updateProductFeed({ productFeed: payload });
            this.$store.commit('setMessages', {
              messages: 'Product feed updated successfully!',
              type: 'success',
            });
          }
        } catch (error) {
          console.log(error);
          this.$store.commit('setMessages', {
            messages: Array.isArray(error)
              ? error.join('. ')
              : error || 'Failed to ' + (this.formAction === 'create' ? 'create' : 'update') + ' product feed!',
            type: 'error',
          });
        } finally {
          this.isSaving = false;
        }
      }
    },
    async loadData() {
      this.isFeedLoading = true;
      try {
        let data = await gmcApi.getProductFeedById(this.feedId);
        const productFeed = data.data.productFeed;

        this.feed = { ...productFeed };

        if (this.feed.collectionsIds && this.feed.collectionsIds.length > 0) {
          this.method = 'Collections';
        }
        if (this.feed.googleProductCategory != null) {
          this.feed.googleProductCategory = this.feed.googleProductCategory.toString();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isFeedLoading = false;
      }
    },
    async submitDelete() {
      this.isDeleteLoading = true;
      try {
        await gmcApi.deleteProductFeed({ id: this.feedId });
        this.$router.push({ name: 'website.product-feeds-v2' });
        this.$store.commit('setMessages', {
          messages: 'Product feed deleted successfully!',
          type: 'success',
        });
      } catch (error) {
        console.log(error);
        this.$store.commit('setMessages', {
          messages: 'Failed to delete product feed!',
          type: 'error',
        });
      } finally {
        this.isDeleteLoading = false;
      }
    },
  },
  computed: {
    existsAllProduct: function() {
      return this.feeds.filter(feed => feed.collectionsIds.length == 0);
    },
  },
};
</script>
<style lang="scss" scoped>
.card-form {
  box-shadow: 0px 2px 10px 0px rgba(124, 141, 181, 0.12);
  background: white;
  border-radius: 2px;
  padding: 16px;
}

.gmc-guide {
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
</style>
